import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { parseISO, format } from 'date-fns';
import { isNull } from 'lodash';

import { UnidataTable } from '~/components';
import { t, number } from '~/helpers';
import { handleExportGeneric } from '~/helpers/exportReports';
import {
  findPrecoProduto,
  recordFiltering,
} from '~/store/modules/precoproduto/actions';

import Form from './form';

function PrecoProdutoList() {
  const redux = useSelector((state) => state.precoproduto);

  const header = useMemo(
    () => [
      {
        id: 'nomeproduto',
        label: t('s.configuracao.produto.nomeproduto'),
        filter: { type: 'text' },
      },
      {
        id: 'datahoraprecoproduto',
        label: t('s.relatorio.afericao.data'),
        formatted: (value) =>
          isNull(value) ? '' : format(parseISO(value), 'dd/MM/yyyy HH:mm'),
      },
      {
        id: 'precoprecoproduto',
        align: 'right',
        label: t('s.configuracao.produto.precoproduto'),
        formatted: (value) => number(value, 3),
      },
    ],
    []
  );

  const fieldlist = [
    'nomeproduto',
    'datahoraprecoproduto',
    'precoprecoproduto',
  ];

  const substituirHeader = {
    nomeproduto: t('s.configuracao.produto.nomeproduto'),
    datahoraprecoproduto: t('s.relatorio.afericao.data'),
    precoprecoproduto: t('s.configuracao.produto.precoproduto'),
  };

  return (
    <UnidataTable
      fixed
      redux={redux}
      header={header}
      read={recordFiltering}
      find={findPrecoProduto}
      form={Form}
      keys="idproduto"
      detach="nomeabreviadoproduto"
      pdf
      excel
      onExport={(formato) =>
        handleExportGeneric({
          endpoint: 'precosprodutos',
          formato,
          fields: fieldlist,
          headers: substituirHeader,
          redux,
          ordination: redux.params.ordination,
          orderfield: redux.params.orderfield,
          title: 'Relatório de Preço Produto',
        })
      }
    />
  );
}

export default PrecoProdutoList;
